import { Base, createApp, importWhenVisible } from '@studiometa/js-toolkit';
import {
  Action,
  Modal,
  Tabs,
  Panel,
  ScrollReveal,
  ScrollAnimationWithEase,
  ScrollAnimation,
} from '@studiometa/ui';
import Cart from './molecules/Cart/index.js';
import Toast from './atoms/Toast/index.js';
import 'liquid-ajax-cart';
import ProductInfo from './organisms/ProductInfo.js';
import SearchForm from './molecules/SearchForm.js';
import Footer from './molecules/Footer.js';
import FooterScrollAnimation from './molecules/FooterScrollAnimation.js';
import PanelDescriptionButton from './molecules/PanelDescriptionButton.js';
import Slider from './molecules/Slider/index.js';
import Header from './organisms/Header.js';
import Navbar from './organisms/Navbar/index.js';
import Facets from './organisms/Facets/index.js';
import StickyBar from './atoms/StickyBar.js';
import Search from './organisms/Search/index.js';
import VariantModal from './molecules/VariantModal.js';
import Splash from './atoms/Splash.js';
import More from './atoms/More.js';

// @note polyfill: toReversed for Array, avoid safari errors on some versions.
if (![].toReversed) {
  Array.prototype.toReversed = function () {
    // eslint-disable-next-line no-var, vars-on-top
    for (var i = this.length - 1, arr = []; i >= 0; --i) {
      arr.push(this[i]);
    }

    return arr;
  };
}

/**
 * App
 */
class App extends Base {
  /**
   * App Configuration
   */
  static config = {
    name: 'App',
    components: {
      Splash,
      Header,
      Navbar,
      VariantModal,
      Action,
      Modal,
      Toast,
      Cart,
      Facets,
      Search,
      ProductInfo,
      SearchForm,
      StickyBar,
      Tabs,
      Footer,
      FooterScrollAnimation,
      ScrollAnimation,
      ScrollAnimationWithEase,
      More,
      Slider,
      SliderHero: (app) =>
        importWhenVisible(() => import('./molecules/SliderHero.js'), 'SliderHero', app),
      ScrollReveal,
      ProductRecommendations: (app) =>
        importWhenVisible(
          () => import('./organisms/ProductRecommendations.js'),
          'ProductRecommendations',
          app,
        ),
      Video: (app) => importWhenVisible(() => import('./atoms/Video.js'), 'Video', app),
      Logo: (app) => importWhenVisible(() => import('./atoms/Logo.js'), 'Logo', app),
      Accordion: (app) =>
        importWhenVisible(() => import('./molecules/Accordion/index.js'), 'Accordion', app),
      PanelDescription: Panel,
      PanelDescriptionButton,
      CollectionLinks: (app) =>
        importWhenVisible(() => import('./molecules/CollectionLinks.js'), 'CollectionLinks', app),
      VisualText: (app) =>
        importWhenVisible(() => import('./molecules/VisualText.js'), 'VisualText', app, {
          threshold: 0.5,
        }),
    },
  };

  /**
   * Toaster
   * @returns {Toast}
   */
  get Toaster() {
    if (this.$children.Toast.length <= 0) {
      throw new Error('No Toast component found');
    }

    return this.$children.Toast[0];
  }

  /**
   * PanelDescription
   * @returns {PanelDescription}
   */
  get PanelDescription() {
    return this.$children.PanelDescription[0];
  }

  /**
   * @returns {boolean}
   */
  iOS() {
    return (
      ['iPad Simulator', 'iPhone Simulator', 'iPod Simulator', 'iPad', 'iPhone', 'iPod'].includes(
        navigator.platform,
      ) ||
      (navigator.userAgent.includes('Mac') && 'ontouchend' in document)
    );
  }

  /**
   * mounted hook
   */
  mounted() {
    document.body.classList.toggle('is-ios', this.iOS());
  }
}

export default createApp(App, document.body);
